import {  CanActivateFn } from '@angular/router';

export const queryParamGuard: CanActivateFn = (route, state) => {
  const queryParams = route.queryParams;
  if ( !route.params['apiKey'] || !queryParams['publisherId'] || !queryParams['placementId'] || !queryParams['adUnitId'] || !queryParams['sessionId']) {
    return false;
  }else return true;


};